'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { ChevronChevronNormalDown } from '@s7/icons';

const IDENT_ACCORDION = 'Accordion';
const accordionDefaultProps = {
    multiple: false,
    disableChevronRotation: false,
    transitionDuration: 200,
    chevronPosition: 'right',
    chevronSize: 24,
    chevron: /*#__PURE__*/ jsx(ChevronChevronNormalDown, {})
};

export { IDENT_ACCORDION, accordionDefaultProps };
//# sourceMappingURL=Accordion.contract.js.map
